/* tslint:disable:triple-equals */
import { Component } from '@angular/core';
import { FilterService } from '../services/filter/filter.service';
import { InstanceQueuePanelFilter } from '../model/filter/instanceQueuePanelFilter.model';
import { ReportService } from '../services/report/report.service';
import { GenericFilter } from '../model/filter/genericFilter.model';
import { InstanceQueueStatusPanelItem } from '../model/report/instanceQueueStatusPanelItem.model';
import { InstanceQueueStatusPanelResult } from '../model/report/instanceQueueStatusPanelResult';
import { ConfigurationService } from '../services/configuration/configuration.service';
import { ListPanelConfigurationUserQueueStatusResult } from '../model/configuration/listPanelConfigurationUserQueueStatusResult.model';
import { PanelConfigurationInstanceQueueStatusMetadata } from '../model/configuration/panelConfigurationInstanceQueueStatusMetadata.model';
import {BehaviorSubject, interval} from 'rxjs';
import 'rxjs/add/operator/map';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'interaction',
  templateUrl: './interactionQueue.component.html',
  styleUrls: ['./interactionQueue.component.css']
})
export class InteractionQueueComponent {
  Filter: GenericFilter;
  MetadataColumns: Array<PanelConfigurationInstanceQueueStatusMetadata> = [];
  ReportItems: Array<InstanceQueueStatusPanelItem> = [];
  IntervalUpdate: number;
  SearchRecycle: boolean;
  isSearching: boolean;
  intervalUpdateSubscription;
  hasSearched: boolean;
  columns = [];
  filterCollapse$: BehaviorSubject<boolean>;

  constructor(private filterService: FilterService, private reportService: ReportService,
    private configurationService: ConfigurationService, private fb: FormBuilder) {
    this.hasSearched = false;
    this.Filter = new GenericFilter();
    this.SearchRecycle = false;
    this.isSearching = false;
    this.columns = [
      {prop: 'userName', name: 'Operador'},
      {prop: 'businessProcessName', name: 'Processo de negócio'},
      {prop: 'stateName', name: 'Estado'},
      {prop: 'timeInAnalysis', name: 'Tempo em análise'}
    ];
    this.getReportConfiguration();
  }

  receiveFilter($event) {
    this.Filter = $event;
    this.onClickSearch();
  }

  getReportConfiguration() {
    this.configurationService.listPanelConfigurationUserQueueStatus().subscribe((resp: ListPanelConfigurationUserQueueStatusResult) => {
      if (resp.result) {
        this.MetadataColumns = resp.result;

        for (const metadataColumn of this.MetadataColumns) {
          this.columns.push({prop: metadataColumn.metadataStructureName, name: metadataColumn.displayName});
        }
      }
    });
  }

  onAutomaticSearchChange() {
    if (this.IntervalUpdate == undefined) {
      return;
    }

    if (this.SearchRecycle) {
      this.intervalUpdateSubscription = interval(this.IntervalUpdate * 1000).subscribe(x => {
        this.onClickSearch();
      });
    } else {
      this.intervalUpdateSubscription.unsubscribe();
    }
  }

  onClickSearch() {
    this.ReportItems = [];
    const reportFilter = new InstanceQueuePanelFilter();

    if (this.isSearching) {
      return;
    }

    this.isSearching = true;
    if (this.Filter.BusinessProcess != undefined) {
      reportFilter.BusinessProcessId = this.Filter.BusinessProcess.id;
    }
    if (this.Filter.State != undefined) {
      reportFilter.StateId = this.Filter.State.id;
    }
    if (this.Filter.User != undefined) {
      reportFilter.UserId = this.Filter.User.id;
    }
    this.reportService.getInstanceQueueStatusPanel(reportFilter).subscribe((resp: InstanceQueueStatusPanelResult) => {

      if (resp != undefined) {
        this.ReportItems = resp.result;

        for (const item of this.ReportItems) {
          if (item.metadataValues.length == 0) {
            item.metadataValues = [];
            for (const column of this.MetadataColumns) {
              item[column.metadataStructureName] = '';
            }
          } else {
            for (const column of this.MetadataColumns) {
              for (const value of item.metadataValues) {
                if (value.metadataStructureName == column.metadataStructureName) {
                  item[column.metadataStructureName] = value.value;
                }
              }
            }
          }
        }

        this.isSearching = false;
        this.hasSearched = true;
      }
    });
  }
}
